// @flow

import * as React from "react";
import { type LinkType } from "../../types/";
import TextButton from "../atoms/TextButton";
import Button from "../atoms/Button";

type PropsType = {
    sectionName: string,
    title?: string | React.Node,
    description?: string,
    cta?: {
        link: LinkType,
        type: string,
    },
};

const SectionHeader = (props: PropsType): React.Node => {
    return (
        <div className={`${props.sectionName}__header row section-header`}>
            <div className="col-xs-12">
                <div
                    className={`${props.sectionName}__header__inner section-header__inner`}
                >
                    {props.sectionName && props.title ? (
                        <h2
                            className={`${props.sectionName}__title section-header__title`}
                        >
                            {props.title}
                        </h2>
                    ) : null}
                    {props.description ? (
                        <p
                            className={`${props.sectionName}__description section-header__description`}
                        >
                            {props.description}
                        </p>
                    ) : null}
                    {props.cta ? (
                        props.cta.type === "button" ? (
                            <Button
                                customButton
                                to={props.cta.link.url}
                                target=""
                                styles={["green"]}
                                className={`${props.sectionName}__header__cta section-header__cta`}
                            >
                                {props.cta.link.title}
                            </Button>
                        ) : (
                            <TextButton
                                customButton
                                to={props.cta.link.url}
                                target=""
                                className={`${props.sectionName}__header__cta section-header__cta`}
                            >
                                {props.cta.link.title}
                            </TextButton>
                        )
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default SectionHeader;
